import { domReady } from "./core/dom-ready.js";
import { initLoadingScreen } from "./modules/loadingScreen.js";
import { initNewsCarousel } from "./modules/newsCarousel.js";
import { initFvNewsCarousel } from "./modules/fvNewsCarousel.js";
import { initFvScrollHint } from "./modules/fvScrollHint.js";
import { initCompanyIntro } from "./modules/companyIntro.js";

// ローディング画面（DOM 準備後すぐ開始。要素がないページでは即終了）
initLoadingScreen();

domReady(() => {
  // FV 右側のSCROLL表示（少しスクロールしたらフェードアウト）
  initFvScrollHint();

  // 会社紹介セクション（画面に入ったら1回だけ表示アニメーション）
  initCompanyIntro();

  // FV専用 NEWS カルーセル（.js-fv-news-carousel が存在するページのみ）
  if (document.querySelector(".js-fv-news-carousel")) {
    initFvNewsCarousel();
  }

  // NEWS カルーセル（.p-news が存在するページのみ）
  if (document.querySelector('.p-news')) {
    initNewsCarousel();
  }
});
